import React from "react"
import { CustomModal } from "./modal"
import { Formik, Form } from "formik"
import Select from "react-select"

function ViewVideoDetails({ isOpen, onClose, video = {}, platforms = [], genders = [] }) {
    const { brief = {} } = video || {}

    // show whatever the brief holds, regardless of video type (custom fields are decided per plan now)
    const text = (v) => (v && typeof v === 'object' ? v.label ?? '' : v ?? '')
    const genderValue = (v) => {
        const raw = String(text(v)).toLowerCase()
        const slug = { m: 'm', male: 'm', f: 'f', female: 'f' }[raw]
        return genders.find(e => e.value === slug)?.label || text(v)
    }
    const extraFields = [
        { key: 'gender', label: 'Gender', value: genderValue(brief?.gender) },
        { key: 'age', label: 'Age', value: text(brief?.age) },
        { key: 'city', label: 'City', value: text(brief?.city) },
        { key: 'dialect', label: 'Dialect', value: text(brief?.dialect) },
        { key: 'is_show_face', label: 'Show face', value: brief?.is_show_face === undefined || brief?.is_show_face === null ? '' : (brief.is_show_face ? 'Yes' : 'No') },
        { key: 'shooting_location', label: 'Shooting location', value: text(brief?.shooting_location) || text(video?.shooting_location) },
        { key: 'special_request', label: 'Special request', value: text(brief?.special_request) || text(video?.special_request) },
    ].filter(f => f.value !== '' && f.value !== null && f.value !== undefined)

    return (
        <CustomModal
            open={isOpen}
            onClose={onClose}
            className="commonCustomModal feedbackModal"
            body={
                <Formik
                    initialValues={{
                        brief: {
                            name: video?.name || '',
                            instructions: video?.instructions || '',
                            content_type: brief?.content_type?.label || '',
                            tone_of_voice: brief?.tone_of_voice?.label || '',
                            language: brief?.language?.label || '',
                            platform: brief?.platform ? video.brief.platform.map(p => p.value) : [],
                            duration: brief?.duration || '',
                            format: brief?.format?.label || '',
                        },
                    }}
                >
                    {({ values }) => (
                        <Form className="form mt-30">
                            <input
                                type="text"
                                name="brief.name"
                                value={values.brief.name}
                                className="stllr-input mb-10"
                                disabled={true}
                                placeholder="Enter video title"
                            />
                            <textarea
                                name="brief.instructions"
                                value={values.brief.instructions}
                                className="stllr-input mb-10"
                                disabled={true}
                                placeholder="Enter video description"
                            ></textarea>
                            <Select
                                name="brief.content_type"
                                isDisabled={true}
                                placeholder={values.brief.content_type}
                                value={null}
                                className="mb-10"
                            />
                            <Select
                                name="brief.tone_of_voice"
                                isDisabled={true}
                                placeholder={values.brief.tone_of_voice}
                                value={null}
                                className="mb-10"
                            />
                            <Select
                                name="brief.language"
                                isDisabled={true}
                                placeholder={values.brief.language}
                                value={null}
                                className="mb-10"
                            />
                            <Select
                                name="brief.platform"
                                options={platforms}
                                isDisabled={true}
                                placeholder="Platform"
                                value={platforms.filter(e => values.brief.platform.includes(e.value))}
                                className="mb-10"
                                isMulti
                            />
                            <Select
                                name="brief.duration"
                                isDisabled={true}
                                placeholder={values.brief.duration}
                                value={null}
                                className="mb-10"
                            />
                            <Select
                                name="brief.format"
                                isDisabled={true}
                                placeholder={values.brief.format}
                                value={null}
                                className="mb-10"
                            />

                            {extraFields.map(({ key, label, value }) => (
                                <div key={key} className="mb-10">
                                    <label className="fs-12 mb-5">{label}</label>
                                    {key === 'special_request' || key === 'shooting_location' ? (
                                        <textarea value={value} className="stllr-input" disabled={true}></textarea>
                                    ) : (
                                        <input type="text" value={value} className="stllr-input" disabled={true} />
                                    )}
                                </div>
                            ))}
                        </Form>
                    )}
                </Formik>
            }
        />
    );
}


export { ViewVideoDetails }